import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu } from 'react-icons/md';
import { NavbarData } from '../../../Data/NavbarData';
import image from '../../../Assets/Images/khadok.png';
import '../../../CSS/Navbar.css';
import useFirebase from '../../../Hooks/useFirebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../../Authentication/firebase.init';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false);
  const [bg, setBg] = useState(false);
  const { logOut } = useFirebase();
  const [user] = useAuthState(auth);

  const signOut = () => {
      logOut();
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      return window.scrollY > 50 ? setBg(true) : setBg(false);
    });
  });


  return (
    <nav className={`${
      bg ? "bg-[#ffffffde] h-16 shadow-sm" : "h-20 text-black"
    } flex items-center app__navbar fixed top-0 w-full text-dark z-50 px-3 transition-all duration-300`}>
      <div className="app__navbar-logo">
        <img className='-py-7' src={image} alt="app__logo" />
      </div>
      <ul className="app__navbar-links">
        {
          NavbarData?.map(data => (
            <li key={data?.name} className="p__opensans"><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to={data?.href}>{data?.name}</NavLink></li>

          ))
        }
      </ul>
      <div className="app__navbar-login">
        {
          user ? <NavLink onClick={signOut} to="/signin" className="p__opensans">Sign Out</NavLink> : 
          <NavLink to="/signin" className="p__opensans">Sign In / Sign Up</NavLink>
        }
        <div />
      </div>
      <div className="app__navbar-smallscreen">
        <GiHamburgerMenu color="#000000" fontSize={27} onClick={() => setToggleMenu(true)} />
        {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
            <MdOutlineRestaurantMenu fontSize={27} className="overlay__close" onClick={() => setToggleMenu(false)} />
            <ul className="app__navbar-smallscreen_links">
              {
                NavbarData?.map(data => (
                  <li className="p__opensans"><NavLink onClick={() => setToggleMenu(false)} className={({ isActive }) => (isActive ? 'active' : 'inactive')} to={data?.href}>{data?.name}</NavLink></li>
                ))
              }
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
